import * as constants from './constants';
import * as g_constants from '../global/constants';

function storeValue(key, obj) {
  try {
    let storingValue = JSON.stringify(obj);
    localStorage.setItem(key, storingValue);
  } catch (err) {
    console.log(err);
  }
}

function retrieveValue(key) {
  try {
    let retrievedValue = localStorage.getItem(key);
    return JSON.parse(retrievedValue);
  } catch (err) {
    console.log(err);
  }
}

function removeValue(key) {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.log(err);
  }
}


const initialFormData = {
  state: uuidv4(),
  firstName: '',
  lastName: '',
  email: '',
  emailValid: null,
  phoneNumber: '',
  notifications: ['email', 'sms'], //Possible Selections: 'email' 'sms'
  cc_token: null,
  password: '',
  passwordConfirm: '',
  profilePhoto: '',
  profileAbout: '',
  profileLoyalties: [],
  referralType: [],
  referralText: '',
  code: null,
  userType: '',
  bill_address1: "",
  bill_address2: "",
  bill_city: "",
  bill_state: "",
  bill_zip: 0,
  signUpMethod: 'email',
  terms: false
};

let initialState = {
  formData: initialFormData,
  photo: null,
  tempUserId: null
};

function uuidv4() {
  let crypto = window.crypto || window.msCrypto;
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}

export default function Registration(state = initialState, action) {
  switch (action.type) {
    case constants.REINITIALIZE_FORM_DATA:
      return Object.assign({}, state, {
        formData: initialFormData
      });
    case constants.UPDATE_FORM_DATA:
      let combinedFormData = Object.assign({}, state.formData, action.data);
      return Object.assign({}, state, {
        formData: combinedFormData
      });
    case constants.UPDATE_PROFILE_PHOTO:
      return Object.assign({}, state, {
        photo: action.data
      });
    case constants.SAVE_FORM_STATE:
      storeValue(state.formData.state, JSON.stringify(state.formData));
      return state;
    case constants.LOAD_FORM_STATE:
      let retrievedFormData = JSON.parse(retrieveValue(action.data));
      return Object.assign({}, state, {
        formData: retrievedFormData
      })
    case g_constants.LOGOUT:
      return Object.assign({}, initialState);
    case constants.TOGGLE_SIGNUP_METHOD:
      return Object.assign({}, state, {
        formData: { ...state.formData, signUpMethod: state.formData.signUpMethod === "email" ? "phone" : "email" }
      })
    case constants.SET_TEMP_USER_ID:
      return Object.assign({}, state, {
        tempUserId: action.data
      })
    case constants.CLEAR_TEMP_USER_ID:
      return Object.assign({}, state, {
        tempUserId: null
      })
    default:
      return state;
  }
}
